import styled, { css } from 'styled-components';
import { InputText } from 'ui/inputs';
import { LeftTooltip } from 'ui/tooltip';
import { Banner } from 'ui/banner';
import { ButtonGroup, GroupButton } from 'ui/buttonGroup';
import { BasicFilterSelect } from 'ui/selects';
import { colors, spacing, subtitle2, Body2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledBanner = styled(Banner)`
  margin-bottom: ${spacing.base};
`;

export const DelayTimeWrapper = styled.div`
  display: flex;
  margin-bottom: ${spacing.plusHalf};
  > div {
    margin-right: ${spacing.half};
    flex: 1;
  }
  > div:last-child {
    margin-right: 0;
  }
`;
export const PropertyDetails = styled.fieldset`
  display: flex;
  align-content: stretch;
  align-items: stretch;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: ${spacing.half};
  padding: 0;
  margin-bottom: ${spacing.base};
  #select-property {
    margin-top: ${spacing.half};
  }
`;

/**
 * See `StyledGroupButton`
 */
export const StyledButtonGroup = styled(ButtonGroup)`
  display: flex;
  align-items: center;
  background: ${colors.grey5};
  border: solid 1px ${colors.grey15};
  border-radius: ${spacing.quarter};
  padding: 0 ${spacing.quarter};
`;

/**
 * TODO: This behave very different than our current core GroupButton, we should probbaly create a new component for it
 * Ex: background for this is expected to be white, whereas the background for current core GroupButton is gray.
 * This can probably be solved by passing in variant props, but the stylings are also different
 * For new ButtonGroup/GroupButton design see: https://www.figma.com/file/fVrTfnFVTu9zE76cgS4GdH/%5BStudio%5D-Studio-modernization
 */
export const StyledGroupButton = styled(GroupButton)`
  border-color: transparent;
  flex: 0 0 auto;
  ${({ isSelected }) =>
    isSelected
      ? css`
          background: ${colors.white};
          color: ${colors.grey80};
        `
      : css`
          background: ${colors.grey5};
          color: ${colors.grey60};
        `}
`;

export const StyledBasicFilterSelect = styled(BasicFilterSelect)`
  flex: 1 1 auto;
  width: auto;

  > div {
    > div {
      width: ${pxToRem(345)};
      > * {
        > span {
          display: flex;
          position: unset;
        }
      }
    }
  }
`;

export const InputWrapper = styled.div`
  margin-bottom: ${spacing.half};
`;

export const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing.plusHalf};
`;

export const Subtitle2 = styled.p`
  ${subtitle2}
`;

export const DelayInputText = styled(InputText)`
  > input {
    width: 100%;
  }
`;

export const StyledLeftTooltip = styled(LeftTooltip)`
  flex: 1 1 100%;
`;

export const Description = styled(Body2)`
  color: ${colors.textSecondary};
  margin-top: ${spacing.base};
  margin-bottom: ${spacing.base};
`;
